import Hero from "./Hero";
import Steps from "./Steps";
import Prize from "./Prize";
import LearnMore from "./LearnMore";
import TimeLine from "./TimeLine";
import CompetitionHistory from "./CompetitionHistory";


export {Hero, Steps, Prize, LearnMore, TimeLine, CompetitionHistory}